// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  message: {
    PrivacyPolicy: 'Privacy Policy',
    my: 'My',
    Loading:'Loading...',
    Todo_Total:"Total",
    Todo_Tasks:"items",
    Nothing:"No data",
    pullingText:"Pull down to refresh",
    loosingText:"release refreshable",
  },
}
